import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  max-width: 1280px;
  max-height: 773px;
  gap: 36px;
`;

export const DashedBox = styled.div`
  width: 1128px;
  height: 440px;
  position: relative;
  gap: 52px;
  border-radius: 12px;
  border: 4px dashed ${({ theme }) => theme.color[3]};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
`;

export const ThemeGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 20px;
  width: 100%;
  max-width: 800px;
`;

export const ThemeItem = styled.div<{ selected: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 240px;
  height: 180px;
  cursor: pointer;
  padding: 10px;
  border-radius: 16px;
  transition: all 0.2s ease-in-out;
  background-color: ${({ theme }) => theme.color[3]};

  > img {
    width: 200px;
    height: 132px;
    object-fit: contain;
    border-radius: 4px;
  }

  > div {
    color: ${({ theme }) => theme.color[2]};
  }
`;

export const PaginationButton = styled.button<{ disabled: boolean }>`
  border: none;
  background: transparent;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease-in-out;

  &:focus {
    outline: none;
  }

  svg {
    width: 80px;
    height: 80px;
  }
`;

export const PageStatus = styled.div`
  position: absolute;
  bottom: 8px;
  right: 8px;
  ${({ theme }) => theme.typography.SEMI_BOLD_24};
  color: ${({ theme }) => theme.color[2]};
`;

export const ThemeConfirmModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  width: 640px;
  height: 640px;
  padding: 12px;
  border-radius: 32px;
  background-color: ${({ theme }) => theme.color[7]};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

export const ModalPreviewImage = styled.img`
  width: 600px;
  height: 480px;
  object-fit: contain;
  border-radius: 8px;
`;

export const ModalButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 100px;
  width: 100%;
`;

export const ModalButton = styled.button<{ primary?: boolean }>`
  width: 180px;
  height: 120px;
  border: none;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.color[3]};
  color: ${({ theme }) => theme.color[5]};
  ${({ theme }) => theme.typography.SEMI_BOLD_24};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
`;
